@import "./components/reset.css";
@import "./components/container.css";
@import "./components/surface.css";
@import "./components/buffering.css";
@import "./components/dialog.css";
@import "./components/controls.css";
@import "./components/time.css";
@import "./components/button.css";
@import "./components/button-group.css";
@import "./components/badge.css";
@import "./components/icons.css";
@import "./components/slider.css";
@import "./components/popup.css";
@import "./components/menus.css";
@import "../../shared/css/audio/icon-state.css";

/* Container */

.media-default-skin--audio {
  --media-default-accent-color: light-dark(oklch(0 0 0), oklch(1 0 0));
  --media-text-color: light-dark(oklch(0 0 0), oklch(1 0 0));
  --media-border-color: oklch(0 0 0 / 0.1);
  --media-focus-ring-color: light-dark(oklch(0 0 0), oklch(1 0 0));

  --media-surface-background-color: light-dark(oklch(1 0 0 / 0.5), oklch(0 0 0 / 0.4));
  --media-surface-inner-border-color: oklch(1 0 0 / 0.1);
  --media-surface-outer-border-color: oklch(0 0 0 / 0.05);
  --media-surface-shadow-color: oklch(0 0 0 / 0.15);
  --media-surface-backdrop-filter: blur(16px) saturate(1.5);

  --media-dialog-transition-duration: 250ms;
  --media-dialog-transition-delay: 100ms;

  --media-popup-transition-duration: 100ms;
  --media-popup-transition-timing-function: ease-out;

  @media (prefers-reduced-motion: reduce) {
    --media-dialog-transition-duration: 50ms;
    --media-dialog-transition-delay: 0ms;
    --media-popup-transition-duration: 0ms;
  }

  @media (prefers-reduced-transparency: reduce) or (prefers-contrast: more) {
    --media-surface-background-color: light-dark(oklch(1 0 0), oklch(0 0 0));
    --media-surface-inner-border-color: light-dark(oklch(1 0 0 / 0.1), oklch(1 0 0 / 0.2));
    --media-surface-outer-border-color: light-dark(oklch(0 0 0 / 0.05), transparent);
  }
}

/* Dialog */

.media-default-skin--audio .media-dialog__dialog {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  gap: calc(var(--media-spacing) * 3);
  align-items: center;
  padding-inline: calc(var(--media-spacing) * 5) calc(var(--media-spacing) * 1);
  color: var(--media-text-color);
  background-color: var(--media-surface-background-color);
  border-radius: calc(infinity * 1px);
  backdrop-filter: var(--media-surface-backdrop-filter);
  transition-delay: var(--media-dialog-transition-delay);
  transition-timing-function: ease-out;
  transition-duration: var(--media-dialog-transition-duration);
  transition-property: opacity, filter;
}

.media-default-skin .media-dialog__popup[data-starting-style] .media-dialog__dialog,
.media-default-skin .media-dialog__popup[data-ending-style] .media-dialog__dialog,
.media-default-skin media-error-dialog[data-starting-style] .media-dialog__dialog,
.media-default-skin media-error-dialog[data-ending-style] .media-dialog__dialog {
  opacity: 0;
  filter: blur(4px);
}
.media-default-skin .media-dialog__popup[data-ending-style] .media-dialog__dialog,
.media-default-skin media-error-dialog[data-ending-style] .media-dialog__dialog {
  transition-delay: 0ms;
}

.media-default-skin--audio .media-dialog__content {
  display: flex;
  flex: 1;
  gap: calc(var(--media-spacing) * 2);
  align-items: center;
}

/* Controls */

.media-default-skin--audio .media-controls {
  --media-base-boundary-offset: 2;
  color: var(--media-text-color);

  .media-time-controls {
    padding-inline: calc(var(--media-spacing) * 3);
  }

  .media-button--seek {
    @container media-root (width < 32rem) {
      display: none;
    }
  }
}

/* Buffering (spinner over play button — backdrop only, no layout change) */

.media-default-skin--audio .media-button--play__wrapper {
  position: relative;
  display: inline-flex;
}

.media-default-skin--audio .media-button--play__wrapper .media-buffering-indicator {
  color: inherit;
}

.media-default-skin--audio
  .media-button--play__wrapper:has(.media-buffering-indicator[data-visible])
  .media-button--play
  .media-icon {
  opacity: 0;
}

/* Sliders */

.media-default-skin--audio .media-slider__track {
  background-color: light-dark(oklch(0 0 0 / 0.1), oklch(1 0 0 / 0.2));
  box-shadow: 0 0 0 1px light-dark(transparent, oklch(0 0 0 / 0.05));
}

.media-default-skin--audio .media-slider .media-slider__preview .media-slider__value {
  bottom: calc(var(--media-spacing) * 10);
}
